// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".containerHome[data-v-62e794cc]{width:100%;height:100vh;background-color:#999;padding:15px 15px}.containerHome .title[data-v-62e794cc]{color:#fff;font-size:20px;font-weight:600;margin-bottom:20px}.containerHome button[data-v-62e794cc]{height:30px;padding:0 8px;margin:5px}", ""]);
// Exports
module.exports = exports;
